import { ChangeDetectorRef, Component, OnInit, Sanitizer, SecurityContext } from '@angular/core';
import { Router } from '@angular/router';
import { takeWhile } from 'rxjs/operators';
import { NoticiaModel } from 'src/app/core/models/noticia.model';
import { NoticiaService } from 'src/app/core/services/noticia.service';
import { BaseComponent } from '../../area-privada/components/base/base.component';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'dum-carousel-noticias',
  templateUrl: './carousel-noticias.component.html',
  styleUrls: ['./carousel-noticias.component.scss']
})
export class CarouselNoticiasComponent extends BaseComponent implements OnInit {

  noticias: NoticiaModel[];
  responsiveOptions;
  imageUpload: File = null;
  urlImageUpload: ArrayBuffer;
  vectorImagenes: ArrayBuffer[] = [];
  imgDefault: string = environment.img_default_news;
  constructor(
    private noticiasService: NoticiaService,
    private router: Router,
    private cd: ChangeDetectorRef,
    private sanitizer: Sanitizer
  ) {
    super();
    this.responsiveOptions = [
      {
        breakpoint: '1700px',
        numVisible: 3,
        numScroll: 3
      },
      {
        breakpoint: '1200px',
        numVisible: 2,
        numScroll: 2
      },
      {
        breakpoint: '992px',
        numVisible: 1,
        numScroll: 1
      }
    ];
    this.noticiasService.findDestacadas()
      .pipe(takeWhile(() => this.alive),
    ).subscribe((noticias) => {
      this.noticias = noticias;
      this.noticias.forEach((noticia) => {
        this.getImage(noticia.id).then((res) => this.vectorImagenes[noticia.id] = res);
      });
    });
  }

  ngOnInit(): void {
  }

    /**
     *
     * @param v
     * @returns {SafeHtml}
     */
    transform(v: string): string
    {
      return this.sanitizer.sanitize(SecurityContext.HTML, v);
    }
  getImage(id: number): Promise<ArrayBuffer> {
    return new Promise((resolved, reject) => {
      this.noticiasService.getImage(id)
        .pipe(takeWhile(() => this.alive))
        .subscribe((imagen) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            resolved(reader.result as ArrayBuffer);
          };
          reader.readAsDataURL(imagen);
        });
    });
  }

  uploadImage(file) {
    if (file.currentFiles.length !== 0) {
      this.imageUpload = file.currentFiles[0];
      this.getUrlImg(this.imageUpload);
    }
  }

  getUrlImg(file) {
    const reader = new FileReader();
    reader.onloadend = () => {
      this.urlImageUpload = reader.result as ArrayBuffer;
    };
    reader.readAsDataURL(file);
  }


  verNoticia(id: number) {
    this.router.navigate([`mostrar-noticia/${id}`]);
  }

}
